import { gql } from '@/__generated__/gql'

export const ContentReferenceDeleteMutation = gql(`
  mutation ContentReferenceDelete($contentReference: ContentReferenceDeleteInput) {
    contentReferenceDelete(contentReference: $contentReference) {
      contentReference {
        id
        fromContentContentId
        fromContentContentType
        toContentContentId
        toContentContentType
        contentReferenceTypesId
      }
    }
  }
`)
